<template>
  <BFormInput
    ref="input"
    type="number"
    v-model="value"
    :step="0.01"
    :min="0"
  ></BFormInput>
</template>

<script>
import { nextTick } from 'vue'

export default {
  data() {
    return {
      value: null
    };
  },
  mounted() {
    this.value = this.params.value;
    nextTick(() => {
      this.$refs.input?.focus()
    })
  },
  methods: {
    getValue() {
      return this.value;
    }
  }
}
</script>